import { useFormContext } from 'react-hook-form';
import { BoolRadioField } from '@views/register/history/history-fields';
import type { TLocalize } from '@hooks/use-localize';
import type { IHistorySocialFormValues, IHistorySocialModel } from '@/types/history/history-social';
import FieldError from '@components/field-error';

interface IProps {
    model: IHistorySocialModel;
    t: TLocalize;
}

const AlcoholSection = ({ model, t }: IProps) => {
    const {
        register,
        watch,
        formState: { errors },
    } = useFormContext<IHistorySocialFormValues>();

    const yes = t('Word_Yes', 'Yes');
    const no = t('Word_No', 'No');

    const hasUsedAlcohol = watch('hasUsedAlcohol');

    return (
        <>
            <BoolRadioField
                name="hasUsedAlcohol"
                label={t('DashLabel_HaveYouEverConsumedAlcohol', 'Have you ever consumed alcohol')}
                yesLabel={yes}
                noLabel={no}
            />

            {hasUsedAlcohol === '1' && (
                <div className="sub-question">
                    <div className="form-group">
                        <label className="control-label col-xs-12">
                            <span className="form-required">*</span>{' '}
                            {t('DashLabel_FrequencyOfAlcoholConsumption', 'Frequency of alcohol consumption')}:
                            <FieldError message={errors.alcoholDrinks?.message} />
                        </label>
                        <div className="col-xs-6">
                            <div className="input-group">
                                <select className="form-control" {...register('alcoholDrinks')}>
                                    <option value="">
                                        {t('DashLabel_SelectNumber', 'Select Number')}
                                    </option>
                                    {Array.from({ length: 20 }, (_, i) => i + 1).map((n) => (
                                        <option key={n} value={n}>
                                            {n}
                                        </option>
                                    ))}
                                </select>
                                <span className="input-group-addon">
                                    <div>{t('DashWord_Drinks', 'drinks')}</div>
                                </span>
                            </div>
                            <FieldError message={errors.alcoholDrinks?.message} />
                        </div>
                        <div className="col-xs-6">
                            <select className="form-control" {...register('alcoholFrequency')}>
                                <option value="">
                                    {t('DashLabel_SelectFrequency', 'Select Frequency')}
                                </option>
                                {model.frequencyOptions.map((o) => (
                                    <option key={o.value} value={o.value}>
                                        {o.label}
                                    </option>
                                ))}
                            </select>
                            <FieldError message={errors.alcoholFrequency?.message} />
                        </div>
                    </div>

                    <BoolRadioField
                        name="usesAlcohol"
                        label={t('DashLabel_DoYouCurrentlyDrinkAlcohol', 'Do you currently drink alcohol')}
                        yesLabel={yes}
                        noLabel={no}
                    />

                    <BoolRadioField
                        name="hasAbusedAlcohol"
                        label={t('DashLabel_DoYouHaveAHistoryOfAbusingAlcohol', 'Do you have a history of abusing alcohol')}
                        yesLabel={yes}
                        noLabel={no}
                    />
                </div>
            )}
        </>
    );
};

export default AlcoholSection;
